import React from 'react';
import renderHTML from 'react-render-html';
import { Desktop, Mobile } from '../../../../app-responsive';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import SummaryDetails from '../../ssm-components/summary-details/summary-details';
import SSMFieldWrapper from '../ssm-field-wrapper/ssm-field-wrapper';
import TextFieldResizable from '../../../../components/form/text-field-resizable';
import FormSelectField from '../../../../components/form/select-field';
import DeviceItem from '../../ssm-components/device-item/device-item';
import DeviceHeader from '../../ssm-components/device-header/device-header';
import {
  BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN,
  BSIP_SERVICE_TERM_DEVICE_TYPE_NTU,
  BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES,
  SERVICE_TERM_ADDITIONAL_INFO,
} from '../../../../app-constants';
import './bsip-service-term.css';

const BsipServiceTerm = (props) => {
  const {
    authorableContent: {
      serviceTermHeading,
      contractTermText,
      serviceTermDescription,
      ntuDefaultQuantity,
      perMonthLabel,
      estimatedOnceoffCharges,
      estimatedMonthlyCharges,
      formFields: {
        contractTerm,
      },
    },
    bsipCallingPlanauthorableContent,
    sitesBsipContractMonthsData,
    siteId,
    bsipServiceTermContractTermSelectionChanged,
    products,
    deviceQuantityOnChange,
    deviceQuantityOnBlur,
    deviceQuantityData,
    sitesBsipCallingPlanSelection,
    numberOfTrunks,
    numberOfPhoneNumbers,
    additionalInfoOnChange,
    additionalInfoOnBlur,
    formFieldsState,
    customerBillingAccountNumber,
    customerAccountNumbers,
    onAccountNumberSelectionOnBlur,
    inDial,
    numberRangesCount,
    serviceTermAuthorableContent: {
      quantityLabel,
      unitPriceLabel,
      priceLabel,
      dateAndInfo,
      billing,
      gstText,
      itemsLabel,
    },
  } = props;

  const {
    formFields,
    additionalInfoHeading,
  } = dateAndInfo;

  const fieldWrapperConfiguration = {
    authorableContent: formFields,
    state: formFieldsState,
    onBlurFunction: additionalInfoOnBlur,
    onChangeFunction: additionalInfoOnChange,
    hasErrors: { SERVICE_TERM_ADDITIONAL_INFO: false },
  };

  const {
    title: billingTitle,
    accountNumberPreText: billingAccountNumberPreText,
    accountNumberPostText: billingAccountNumberPostText,
    accountNumberLabel: billingAccountNumberLabel,

  } = billing;

  const {
    title: estimatedOnceOffTitle,
    tooltip: estimatedOnceOffToolTip,
  } = estimatedOnceoffCharges;

  const {
    title: estimatedMonthlyTitle,
    tooltip: estimatedMonthlyToolTip,
  } = estimatedMonthlyCharges;


  const defaultBillingAccountNumber = customerAccountNumbers[0];
  const customerBIllingAccountInformationText = `${billingAccountNumberPreText} ${defaultBillingAccountNumber}. ${billingAccountNumberPostText}`;

  const billingAccountNumberOptions = customerAccountNumbers.map(accountNumber => (
    {
      id: accountNumber,
      value: accountNumber,
    }
  ));

  const getItemTitle = (item) => {
    const callingPlanSelected = sitesBsipCallingPlanSelection[siteId];
    const planName = bsipCallingPlanauthorableContent[callingPlanSelected].planName;
    return `${item.title} ${planName}`;
  };

  const getCallingPlanUnitPriceText = () => {
    const callingPlanSelected = sitesBsipCallingPlanSelection[siteId];
    const priceText = bsipCallingPlanauthorableContent[callingPlanSelected].priceText;
    return priceText;
  };

  const getUnitRentalPrice = (item, product) => {
    switch (product.deviceType) {
      case BSIP_SERVICE_TERM_DEVICE_TYPE_NTU: {
        const contractTermSelectionText = sitesBsipContractMonthsData && sitesBsipContractMonthsData[siteId];
        const contractTermMonths = parseInt(contractTermSelectionText.split(' ')[0], 10);
        const returnValue = parseInt(item.rentalPrice, 10) / contractTermMonths;
        return (Number.isInteger(returnValue) ? returnValue : returnValue.toFixed(2));
      }
      case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
        const callingPlanSelected = sitesBsipCallingPlanSelection[siteId];
        const priceText = bsipCallingPlanauthorableContent[callingPlanSelected].priceText;
        const priceValueText = priceText.split('/')[0].replace('$', '');
        return parseInt(priceValueText, 10);
      }
      default:
        return item.rentalPrice;
    }
  };

  const devices = product => product.items.map((item) => {
    const deviceType = product.deviceType;

    const deviceQuanityDataItem = deviceQuantityData.filter(
      quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0];

    let quantityValue = 0;

    switch (deviceType) {
      case BSIP_SERVICE_TERM_DEVICE_TYPE_NTU: {
        quantityValue = parseInt(ntuDefaultQuantity, 10);
        break;
      }
      case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
        quantityValue = numberOfTrunks;
        break;
      }
      case BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES: {
        if (inDial === false && item.itemName === 'singleNumber') { // single number item for multinumber product
          quantityValue = numberOfPhoneNumbers;
        } else if (inDial === false && item.itemName === 'first100numberblock') {
          quantityValue = 0;
        } else if (inDial === false && item.itemName === 'subsequent100numberblocks') {
          quantityValue = 0;
        } else if (inDial && item.itemName === 'singleNumber') {
          quantityValue = 0;
        } else if (inDial && item.itemName === 'first100numberblock') {
          quantityValue = numberRangesCount > 0 ? 1 : 0;
        } else if (inDial && item.itemName === 'subsequent100numberblocks') {
          quantityValue = numberRangesCount > 0 ? numberRangesCount - 1 : 0;
        }
        break;
      }
      default:
        quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : '';
    }
    const labels = { device: product.label, quantity: quantityLabel, unit: unitPriceLabel, price: priceLabel, toolTip: product.summary };

    const emptyDeviceQuantityData = 0;
    return (
      <DeviceItem
        key={`${deviceType}-${item.itemName}-${siteId}`}
        deviceKey={`${deviceType}-${item.itemName}-${siteId}`}
        deviceName={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN ? getItemTitle(item) : item.title}
        readOnlyQuantity={product.readOnlyQuantities}
        linkText={item.linkText}
        linkURL={item.linkURL}
        deviceToolTipText={item.tooltip}
        deviceToolTipImagePath={item.tooltipImg}
        unitPricePurchaseValue={item.purchasePrice}
        unitPriceRentalValue={getUnitRentalPrice(item, product)}
        unitPriceSuffixText={perMonthLabel}
        paymentType={product.paymentType}
        serviceTermSelectedOption="rental"
        quantityValue={quantityValue}
        quantityInputOnChange={deviceQuantityOnChange}
        quantityInputOnBlur={deviceQuantityOnBlur}
        quantityMin={emptyDeviceQuantityData}
        labels={labels}
        emptyDeviceQuantityData={emptyDeviceQuantityData}
        bsipUnitPriceSuffixText={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN ?
          getCallingPlanUnitPriceText() : item.priceAdditionalText}
        bsipItem
        unitPriceTextOverride={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN}
      />
    );
  });

  const monthlyTotalCost = (services) => {
    let totalCost = 0;
    services.forEach((service) => {
      service.items.forEach((item) => {
        const deviceType = service.deviceType;
        const deviceQuanityDataItem = deviceQuantityData.filter(
          quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0];
        let quantityValue = 0;
        switch (deviceType) {
          case BSIP_SERVICE_TERM_DEVICE_TYPE_NTU: {
            quantityValue = parseInt(ntuDefaultQuantity, 10);
            break;
          }
          case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
            quantityValue = numberOfTrunks;
            break;
          }
          case BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES: {
            if (inDial === false && item.itemName === 'singleNumber') { // single number item for multinumber product
              quantityValue = numberOfPhoneNumbers;
            } else if (inDial === false && item.itemName === 'first100numberblock') {
              quantityValue = 0;
            } else if (inDial === false && item.itemName === 'subsequent100numberblocks') {
              quantityValue = 0;
            } else if (inDial && item.itemName === 'singleNumber') {
              quantityValue = 0;
            } else if (inDial && item.itemName === 'first100numberblock') {
              quantityValue = numberRangesCount > 0 ? 1 : 0;
            } else if (inDial && item.itemName === 'subsequent100numberblocks') {
              quantityValue = numberRangesCount > 0 ? numberRangesCount - 1 : 0;
            }

            break;
          }
          default:
            quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : 0;
        }
        totalCost += (quantityValue * getUnitRentalPrice(item, service));
      });
    });
    return totalCost;
  };


  const monthlyTotal = (services => monthlyTotalCost(services));

  const contractTermSelectionText = sitesBsipContractMonthsData && sitesBsipContractMonthsData[siteId];
  const monthlyTitle = `${estimatedMonthlyTitle} ${contractTermSelectionText} ${gstText}`;

  return (
    <div className="bsip-service-term">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="bsip-service-section-heading" className="bsip-service-section-heading">{serviceTermHeading}</h2>
        </div>
      </div>
      <div className="row dropdown-row">
        <div className="col-md-6 col-sm-12 pl-sm-0 dropdown-contract-term">
          <span>{contractTermText}</span>
        </div>
        <div className="col-md-3">
          <FormSelectField
            id="contract-term-month-selection"
            label=""
            disabled={false}
            options={contractTerm.options}
            value={sitesBsipContractMonthsData && sitesBsipContractMonthsData[siteId]}
            onBlur={bsipServiceTermContractTermSelectionChanged}
            placeholder=""
            initialValuePresent
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0">
          <span className="service-term-description">{renderHTML(serviceTermDescription)}</span>
        </div>
      </div>
      <DeviceHeader
        deviceNameHeadingText={itemsLabel}
        quantityHeadingText={quantityLabel}
        unitPriceHeadingText={unitPriceLabel}
        priceNameHeadingText={priceLabel}
      />
      {products.map(product =>
        (<div key={`${product.deviceType}-bsip-device-${siteId}`} >
          <div className={`bsip-devices ${product.deviceType}-bsip-devices`}>
            {devices(product)}
          </div>
        </div>),
      )}

      <Desktop>
        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-description">
            <div>
              {estimatedOnceOffTitle}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-once-off-cost-tooltip"
                toolTipText={estimatedOnceOffToolTip}
              />
            </div>
          </div>

          <div className="col-md-6 estimated-monthly-cost estimated-cost-description">
            <div>
              {monthlyTitle}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-price">
            <div>
              <div className="total-price-estimate"><sup>$</sup>
              0
              </div>
            </div>
          </div>
          <div className="col-md-6 estimated-monthly-cost estimated-cost-price">
            <div className="total-price-estimate"><sup>$</sup>
              {Number.isInteger(monthlyTotal(products)) ? monthlyTotal(products) :
                monthlyTotal(products).toFixed(2)}<sub>{perMonthLabel}</sub></div>
          </div>
        </div>
      </Desktop>
      <Mobile>
        <div className="row estimated-once-off-cost mobile-seperation">
          <div className="col-12 estimated-cost-description">
            {estimatedOnceOffTitle}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="estimated-once-off-cost-tooltip"
              toolTipText={estimatedOnceOffToolTip}
            />
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate"><sup>$</sup>
              0
            </div>
          </div>
        </div>

        <div className="row estimated-monthly-cost">
          <div className="col-12  estimated-cost-description">
            <div>
              {monthlyTitle}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate"><sup>$</sup>
              {Number.isInteger(monthlyTotal(products)) ? monthlyTotal(products) :
                monthlyTotal(products).toFixed(2)}<sub>{perMonthLabel}</sub></div>
          </div>
        </div>
      </Mobile>


      <div className="billing-section">
        <SummaryDetails
          summaryTitle={billingTitle}
          summaryText={customerBIllingAccountInformationText}
        />
      </div>
      <div className="row">
        <div className="input-label col-md-2 pl-sm-0">
          {billingAccountNumberLabel}
        </div>
        <div className="col-md-3">
          <FormSelectField
            id="service-term-billing-accounts-list"
            label=""
            disabled={false}
            options={billingAccountNumberOptions}
            value={customerBillingAccountNumber}
            onBlur={onAccountNumberSelectionOnBlur}
            placeholder=""
            initialValuePresent
          />
        </div>
      </div>
      <div className="row additional-info-section">
        <div className="col pl-sm-0">
          <h2 id="summary-heading" className="summary-heading">{additionalInfoHeading}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={TextFieldResizable}
            id={SERVICE_TERM_ADDITIONAL_INFO}
            customClass="block-spacer"
          />
        </div>
      </div>
    </div>
  );
};

export default BsipServiceTerm;
